export enum ItemState {
  PENDING = 'PENDING',
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
  REJECTED = 'REJECTED',
  CANCELED = 'CANCELED'
}

export enum ItemStateColors {
  PENDING = '#B2B6BA',
  ADDED = '#29A829',
  REMOVED = '#F9D350',
  REJECTED = '#EC5B5E',
  CANCELED = '#EC5B5E'
}

export enum ItemUser {
  CLIENT = 'CLIENT',
  PICKER = 'PICKER',
  DRIVER = 'DRIVER',
  AGENT = 'AGENT'
}
